import React from 'react';
import { shape, string } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import ContextMenu from './ContextMenu';

const ActionCell = ({ row, ...props }) => {
    let Component = ContextMenu;

    return (
        <Table.Cell key={row.id} {...props}>
            <Component rule={row} />
        </Table.Cell>
    );
};

ActionCell.defaultProps = {
    row: {}
};

ActionCell.propTypes = {
    row: shape({
        recalculationStatus: string
    })
};

export default ActionCell;
